import { emitter } from '@/plugins/mitt.js';
import state from '../state.js';

const bemBlock = 'focus-mask-container';

/**
 * Adds or removes a focus class to the given element based on the current focus state.
 *
 * @param {Element} el - The DOM element which carries the directive.
 */
function updated(el) {
  const visibleModifier = `${bemBlock}--visible`;
  const variantModifier = `${bemBlock}--variant-${state.variant}`;
  const hidingModifier = `${bemBlock}--hiding`;

  if (state.enabled) {
    // This will also make the directive reactive to the observable.
    el.classList.add(visibleModifier);
    el.classList.add(variantModifier);
  } else {
    /**
     * Removes all modifier classes after transition ended.
     */
    const removeClasses = () => {
      el.classList.remove(visibleModifier);
      el.classList.remove(variantModifier);
      el.classList.remove(hidingModifier);
      el.removeEventListener('transitionend', removeClasses);
      window.removeEventListener('click', removeClasses);
    };

    el.addEventListener('transitionend', removeClasses);
    window.addEventListener('click', removeClasses); // Prevents edge cases.

    el.classList.add(hidingModifier);
  }
}

/**
 * A directive to show an overlay inside the bound element.
 */
export default {
  name: 'focus-mask',

  beforeMount(el) {
    emitter.on('check-focus', () => {
      updated(el);
    });

    el.classList.add(bemBlock);

    if (state.enabled) {
      updated(el);
    }
  },

  updated,
};
